import React from 'react';
import { DataGridLayout, DESC, GetDataMethodType, List, RelationListLayout, SearchInput } from 'framework/list';

type VendorDocumentsListProps = {
  filters?: React.ReactElement;
  getDataMethod: GetDataMethodType;
  children: React.ReactNode;
  actions?: React.ReactElement[];
  itemButtons?: React.ReactElement[];
};

const DocumentsListWrapper = ({ filters, getDataMethod, children, actions, itemButtons }: VendorDocumentsListProps) => {
  return (
    <List getDataMethod={getDataMethod} defaultSortField="createdAt" defaultSortOrder={DESC}>
      <RelationListLayout
        filter={filters}
        search={<SearchInput label="File" />}
        header="Documents"
        headerVariant="h4"
        actions={actions}
        isSmallLoader={false}
        sxHeaderContainer={{
          mb: '15px !important',
        }}
        sxFilter={{
          mb: '10px !important',
        }}
      >
        <DataGridLayout
          isInitialLoaderPosition
          buttons={itemButtons}
          sxTableWrapper={{
            '&& .MuiTableCell-root': { padding: '6px' },
          }}
        >
          {children}
        </DataGridLayout>
      </RelationListLayout>
    </List>
  );
};

export default DocumentsListWrapper;
